import Component from 'inferno-component';
import { connect } from 'inferno-redux';
import Page from '../components/Page';
import { Link } from 'inferno-router';
import { getCognitoUser, verifyAttribute, getAttributeVerificationCode } from '../redux/auth';

function mapStateToProps(state) {
  return {
    state,
  };
}

class UserVerified extends Component {
  constructor(props) {
    super(props);

    this.state = {
      successMessage: false,
      error: null,
    };
  }
  componentDidMount() {
    const { verificationCode } = this.props.params;
    if (!verificationCode) {
      return window.location.href = '/';
    }
    this.props
      .getCognitoUser()
      .then(userInfo => {
        if(userInfo.email_verified === "true") {
          return this.setState({ successMessage: "Your account has already been verified!" });
        }
        return this.props.verifyAttribute("email", verificationCode)
          .then(result => {
            this.setState({
              successMessage: 'Your account changes have been verified!',
            });
          })
          .catch(err => {
            if(err.message === "User is not logged in") {
              this.setState({ error: "Authentication required. Redirecting to login..." });
              return window.location.href = `/login?verificationCode=${verificationCode}`;
            }
            if(err.code === "ExpiredCodeException") {
              this.setState({ error: "This code has expired. Please check your email for a new one and try again." });
              return this.props.getAttributeVerificationCode("email");
            }
            this.setState({ error: err.message });
          });
      })
      .catch(err => {
        this.setState({ error: "Authentication required. Redirecting to login..." });
        return window.location.href = `/login?verificationCode=${verificationCode}`;
      });
  }

  render() {
    return (
      <Page>
        <div className="confirmed__container">
          {this.state.error && (
            <div>
              <h1 className="section__title">
                Sorry! An unexpected error occurred
              </h1>
              {this.state.error}
            </div>
          )}
          {this.state.successMessage && (
            <div>
              <h1 className="section__title">Verified!</h1>
              {this.state.successMessage}
              <Link className="link" to="/word-of-the-day">
                View the word of the day
              </Link>
            </div>
          )}
        </div>
      </Page>
    );
  }
}

export default connect(mapStateToProps, { getCognitoUser, verifyAttribute, getAttributeVerificationCode })(UserVerified);



// WEBPACK FOOTER //
// ./src/pages/UserVerified.js